import { render } from "./MainNav.vue?vue&type=template&id=297ae25a&scoped=true"
import script from "./MainNav.vue?vue&type=script&lang=js"
export * from "./MainNav.vue?vue&type=script&lang=js"

import "./MainNav.vue?vue&type=style&index=0&id=297ae25a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-297ae25a"

export default script